import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { find, flatten, intersectionWith, orderBy, pullAllBy, reduce, sumBy, uniqBy, uniqWith } from 'lodash'
import { connect } from 'react-redux'
import ListComponent from '../../../components/list/ListComponent'
import DtoStation from '../../dto/DtoStation'
import DtoSamplingPoint from '../../dto/DtoSamplingPoint'
import DtoType from '../../../referential/dto/DtoSiteType'
import DtoStationRow from '../../dto/DtoStationRow'
import SiteTypes from '../../../utils/mapUtils/SiteTypes'
import CheckPanel from '../../../components/panel/CheckPanel'
import AppStore from '../../../store/AppStore'
import SitesAction from '../../../sites/actions/SitesAction'
import DtoKeyFigures from '../../dto/DtoKeyFigures'
import { getDate } from '../../../utils/DateUtil'
import { getPlurial } from '../../../utils/StringUtils'
import filter from 'lodash/filter'
import DtoIndicatorType from '../../../referential/dto/DtoIndicatorType'
import DtoCityIndicator from '../../dto/DtoCityIndicator'
import DtoIndicator from '../../../referential/dto/DtoIndicator'
import i18n from 'simple-react-i18n'
import DtoCityInformation from '../../dto/DtoCityInformation'
import DtoSelectionRow from '../../../dashboard/dto/DtoSelectionRow'
import ThemeDto from '../../../administration/dto/ThemeDto'
import { getColor } from '../../../utils/ThemesUtils'
import DtoWatershed from '../../dto/DtoWatershed'
import DtoLayer from '../../../administration/dto/DtoLayer'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import Typography from '@material-ui/core/Typography'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'

class StationTabPanel extends Component {
	constructor(props) {
		super(props)
		this.onHoverFunction = this.onHoverFunction.bind(this)
	}

	onHoverFunction(data) {
		if (this.props.onHover) {
			if (data) {
				AppStore.dispatch(SitesAction.setCoordinatesHover({
					id: data.id,
					type: data.typeParameter
				}))
			}
		}
	}

	getTitle = (station) => {
		const title = station.name != station.code ? station.code + ' - ' + station.name : station.code
		return (
			<span className='truncate font-size-12'>{ title }</span>
		)
	}

	getBackgroundColor = (station) => {
		const findStation = find(this.props.selectedStations, (o) => {
			return o.id == station.id
		})
		if (!findStation) {
			return 'rgba(128,128,128, 0.1)'
		}
		return 'white'
	}

	getInfoComponent = (data, date, label, labelPlurial = label) => {
		const finalLabel = data > 1 ? labelPlurial : label
		const last = data > 1 ? i18n.multi.lastMin : i18n.lastMin
		return (
			<div className='row no-margin'>
				<div className='col s12 no-padding'>
					<div className='row no-margin'>
						<span>{ data } { finalLabel } : { last } { finalLabel } { getDate(date) }</span>
					</div>
				</div>
			</div>
		)
	}

	getDefaultDescription = station => {
		return (
			<div className='row no-margin' onMouseLeave={ () => this.onHoverFunction({}) }
				 onMouseEnter={ () => this.onHoverFunction(station) }>
				{ this.getTitle(station) }
				<div/>
			</div>
		)
	}

	getNbMeasures = (station, keyFigure) => {
		return (
			<div className='row no-margin' onMouseLeave={ () => this.onHoverFunction({}) }
				 onMouseEnter={ () => this.onHoverFunction(station) }>
				{ this.getTitle(station) }
				<div className={ 'row no-margin left' }>
					<div className={ 'col s12 no-padding' }>
						{ this.getInfoComponent(keyFigure.nbMeasure, keyFigure.endDate, i18n.measureMin, i18n.measuresMin) }
					</div>
				</div>
			</div>
		)
	}

	getPiezometerDescriptions = station => {
		const keyFigure = station.keyFigure
		if (keyFigure) {
			return this.getNbMeasures(station, keyFigure)
		}
		return this.getDefaultDescription(station)
	}

	getPluviometerDescriptions = station => {
		const keyFigure = station.keyFigure
		if (keyFigure) {
			return this.getNbMeasures(station, keyFigure)
		}
		return this.getDefaultDescription(station)
	}

	getQualitometerDescriptions = station => {
		const keyFigure = station.keyFigure
		if (keyFigure) {
			const endDate = keyFigure.endDate ? getDate(keyFigure.endDate) : ''
			const nbAnalyse = keyFigure.nbAnalysis ? keyFigure.nbAnalysis : 0
			if (nbAnalyse) {
				return (
					<div className='row no-margin' onMouseLeave={ () => this.onHoverFunction({}) }
						 onMouseEnter={ () => this.onHoverFunction(station) }>
						{ this.getTitle(station) }
						<div className={ 'row no-margin left' }>
							<div className={ 'col s12 no-padding' }>
								{ this.getInfoComponent(nbAnalyse, endDate, i18n.lowerAnalysis, i18n.lowerAnalyses) }
							</div>
						</div>
					</div>
				)
			}
			return this.getDefaultDescription(station)
		}
		return this.getDefaultDescription(station)
	}

	getSurfaceQualitometerDescriptions(station) {
		const keyFigures = station.keyFigures
		if (keyFigures && keyFigures.length) {
			const sumAnalysis = sumBy(keyFigures, 'nbAnalysis')
			const sortKeyFigures = orderBy(keyFigures, ['endDate'], ['desc'])
			return (
				<div className='row no-margin' onMouseLeave={ () => this.onHoverFunction({}) }
					 onMouseEnter={ () => this.onHoverFunction(station) }>
					{ this.getTitle(station) }
					<div className={ 'row no-margin left' }>
						<div className={ 'col s12 no-padding' }>
							{ this.getInfoComponent(sumAnalysis, sortKeyFigures.endDate, i18n.lowerAnalysis, i18n.lowerAnalyses) }
						</div>
					</div>
				</div>
			)
		}
		return this.getDefaultDescription(station)
	}

	getWaterServiceCheck = () => {
		const findService = find(this.props.selectedThemes, (o) => {
			return o.value.id == '8'
		})
		return !!findService
	}

	getCityDescription = (point) => {
		if (this.props.cityInformations.length) {
			const findCity = find(this.props.cityInformations, (o) => {
				return o.code == point.code
			})
			const cityInformation = (() => {
				if (findCity && findCity.population) {
					return (
						<div className={ 'row no-margin' }>
							<span>{ i18n.population }</span> : { findCity.population }
						</div>
					)
				}
				return null
			})()
			const waterServiceCheck = this.getWaterServiceCheck()

			const completeCityInformation = (() => {
				if (waterServiceCheck) {
					if (this.props.indicatorTypes.length && this.props.cityIndicators.length && this.props.indicators.length) {
						const filterIndicators = filter(this.props.cityIndicators, (o) => {
							return o.stationId == point.id
						})
						if (filterIndicators.length) {
							const listOfIndicators = intersectionWith(this.props.indicators, filterIndicators, (a, b) => {
								return a.id == b.indicatorId
							})
							if (listOfIndicators.length) {
								const reduceType = reduce(listOfIndicators, (result, value) => {
									(result[value.typeId] || (result[value.typeId] = [])).push(value)
									return result
								}, {})
								return Object.keys(reduceType).map(o => {
									const indicatorType = find(this.props.indicatorTypes, (type) => {
										return type.id == o
									})
									const listOfCityIndicators = orderBy(intersectionWith(filterIndicators, reduceType[o], (a, b) => {
										return a.indicatorId == b.id
									}), ['date'], ['desc'])
									const lastDate = listOfCityIndicators[0].date
									const nbIndicators = listOfCityIndicators.length
									return (
										<div className={ 'row no-margin' } key={ o }>
											<span>{ indicatorType.mnemonique }</span> : { nbIndicators } { getPlurial(i18n.indicatorMin, i18n.indicatorsMin, nbIndicators) } { getDate(lastDate) }
										</div>
									)
								})
							}
							return null
						}
						return null
					}
					return null
				}
				return null
			})()

			return (
				<div className='row no-margin' onMouseLeave={ () => this.onHoverFunction({}) }
					 onMouseEnter={ () => this.onHoverFunction(point) }>
					<h6>{ this.getTitle(point) }</h6>
					<div className={ 'row no-margin left' }>
						<div className={ 'col s12 no-padding' }>
							{ cityInformation }
							{ completeCityInformation }
						</div>
					</div>
				</div>
			)
		}
		return this.getDefaultDescription(point)
	}

	getComponentOfType = (station, type) => {
		switch (type) {
			case SiteTypes.QUALITOMETER.type:
			case SiteTypes.QUALITOMETER_SURFACE.type:
				return this.getQualitometerDescriptions(station)
			case SiteTypes.PIEZOMETER.type:
				return this.getPiezometerDescriptions(station)
			case SiteTypes.PLUVIOMETER.type:
				return this.getPluviometerDescriptions(station)
			case SiteTypes.CITY.type:
				return this.getCityDescription(station)
			case SiteTypes.FISHING_PLACE.type:
				return this.getDefaultDescription(station)
			default:
				return this.getDefaultDescription(station)
		}
	}

	addOrRemoveSelectedStations = (idType, isCheck) => {
		const selectedStations = Object.assign([], this.props.selectedStations)
		if (isCheck) {
			const stationToAdd = filter(this.props.stations, (o) => {
				return o.typeId == idType
			})
			return uniqWith([].concat(selectedStations, stationToAdd), (a, b) => {
				return a.id === b.id
			})
		}
		const stationToRemove = filter(selectedStations, (o) => {
			return o.typeId == idType
		})
		return pullAllBy(selectedStations, stationToRemove, 'id')
	}

	resetAllTypeFunction = (idType, isCheck) => {
		const stationSelected = this.addOrRemoveSelectedStations(idType, isCheck)
		AppStore.dispatch(SitesAction.setSelectedStations(stationSelected))
	}


	getCheckTypes = (typeId, watershedId = null, stationsType = undefined) => {
		const listOfSites = (() => {
			if (stationsType) {
				return filter(this.props.selectedStations, (o) => {
					return find(stationsType, (b) => {
						return b.id === o.id
					})
				})
			}
			return this.props.selectedStations
		})()
		if (listOfSites) {
			return !!filter(listOfSites, (o) => {
				if (watershedId) {
					return o.typeId === typeId && o.idWatershed == watershedId
				}
				return o.typeId === typeId
			}).length
		}
		return false
	}

	getCheckStation(idStation) {
		if (this.props.selectedStations.length) {
			const result = find(this.props.selectedStations, o => o.id === idStation)
			return !!result
		}
		return false
	}

	getReduceFilterType = (stations, watershedId = null) => {
		const listOfStations = (() => {
			if (watershedId) {
				return filter(stations, (o) => o.idWatershed === watershedId)
			}
			return stations
		})()
		return reduce(listOfStations, (result, value) => {
			const tmpType = SiteTypes.getType(value.typeId, this.props.siteTypes);
			(result[tmpType.type] || (result[tmpType.type] = [])).push(value)
			return result
		}, {})
	}

	getListOfStationWithKeyFigures = (listOfStation, siteType) => {
		return orderBy(listOfStation.map(station => {
			const keyFigures = (() => {
				if (siteType) {
					return find(this.props.keyFigures, o => {
						return o.typeId == siteType.id && o.stationId == station.id
					})
				}
				return find(this.props.keyFigures, o => {
					return o.stationId == station.id
				})
			})()
			const nbKeyFigures = (() => {
				if (keyFigures) {
					return keyFigures.nbAnalysis + keyFigures.nbMeasure
				}
				return 0
			})()
			return Object.assign({}, station, {
				keyFigure: keyFigures,
				nbKeyFigures: nbKeyFigures
			})
		}), 'nbKeyFigures', 'desc')
	}

	addOrRemoveSelectedStationsWithIdWaterSged = (idWatershed, isCheck) => {
		const selectedStations = Object.assign([], this.props.selectedStations)
		if (isCheck) {
			const stationToAdd = filter(this.props.stations, (o) => {
				return o.idWatershed == idWatershed
			})
			return uniqWith([].concat(selectedStations, stationToAdd), (a, b) => {
				return a.id === b.id
			})
		}
		const stationToRemove = filter(selectedStations, (o) => {
			return o.idWatershed == idWatershed
		})
		return pullAllBy(selectedStations, stationToRemove, 'id')
	}

	checkWaterShed = (idWatershed, isCheck) => {
		const stationSelected = this.addOrRemoveSelectedStationsWithIdWaterSged(idWatershed, isCheck)
		AppStore.dispatch(SitesAction.setSelectedStations(stationSelected))
	}
	getWatershedTabs = () => {
		const entities = []
		if (this.props.watershedSelected.length) {
			this.props.watershedSelected.forEach((watershed) => {
				const filterByTypes = this.getReduceFilterType(this.props.stations, watershed.id)
				const sites = uniqBy(flatten(orderBy(filter(this.props.selectedThemes, ['value.disable', false]), ['value.id'], ['asc']).map(theme => {
					return theme.value.siteTypes.filter(o => filterByTypes[o.type] && filterByTypes[o.type].length).map(st => {
						const type = st.type
						const typeSize = filterByTypes[type].length
						const siteType = this.props.siteTypes.find(o => o.parameter == type)
						const finalStation = this.getListOfStationWithKeyFigures(filterByTypes[type], siteType)
						const stationList = finalStation.map((station, i) => {
							const stationRow = new DtoStationRow(station)
							const checkedStation = this.getCheckStation(station.id)
							return (
								<CheckPanel key={ i }
											onToggleCheck={ () => AppStore.dispatch(SitesAction.toggleSelectedStations(station)) }
											backgroundColor={ this.getBackgroundColor(station) }
											checked={ checkedStation }>
									{ this.getComponentOfType(stationRow, type) }
								</CheckPanel>
							)
						})
						const idType = siteType.id
						const isChecked = this.getCheckTypes(idType, watershed.id)
						return {
							title: SiteTypes[type].name(typeSize) + ' (' + typeSize + ')',
							component: stationList,
							lightMode: true,
							picture: SiteTypes[type].icon,
							id: idType,
							isChecked: isChecked
						}
					})
				})), 'id')
				const waterShedCheck = !!this.props.selectedStations.filter(o => o.idWatershed == watershed.id).length
				const nbSites = sumBy(sites, (a) => {
					return a.component.length
				})
				const result = {
					title: `${ watershed.code } - ${ watershed.name } (${ nbSites })`,
					id: watershed.id,
					component: (
						<ListComponent tables={ sites } generalFunction={ this.resetAllTypeFunction }/>),
					isChecked: waterShedCheck
				}
				entities.push(result)
			})
		}
		return <ListComponent tables={ entities } generalFunction={ this.checkWaterShed }/>
	}

	getTabs = () => {
		const entities = []
		const filterByTypes = this.getReduceFilterType(this.props.stations)
		orderBy(filter(this.props.selectedThemes, ['value.disable', false]), ['value.id'], ['asc']).forEach(theme => {
			const color = getColor(this.props.themes, theme.value, 1)
			const finalSiteTypes = theme.value.siteTypes.filter(o => filterByTypes[o.type] && filterByTypes[o.type].length)
			const size = finalSiteTypes.length
			if (size) {
				const siteTypes = finalSiteTypes.map(st => {
					const type = st.type
					const typeSize = filterByTypes[type].length
					const siteType = this.props.siteTypes.find(o => o.parameter == type)
					const finalStation = this.getListOfStationWithKeyFigures(filterByTypes[type])
					const stationList = finalStation.map((station, i) => {
						const stationRow = new DtoStationRow(station)
						const checkedStation = this.getCheckStation(station.id)
						return (
							<CheckPanel key={ i }
										onToggleCheck={ () => AppStore.dispatch(SitesAction.toggleSelectedStations(station)) }
										backgroundColor={ this.getBackgroundColor(station) } checked={ checkedStation }>
								{ this.getComponentOfType(stationRow, type) }
							</CheckPanel>
						)
					})
					const idType = siteType.id
					const isChecked = this.getCheckTypes(idType)
					return {
						title: SiteTypes[type].name(typeSize) + ' (' + typeSize + ')',
						component: stationList,
						lightMode: true,
						picture: SiteTypes[type].icon,
						id: idType,
						isChecked: isChecked
					}
				})
				const result = {
					title: `${ theme.label } (${ sumBy(siteTypes, (a) => {
						return a.component.length
					}) })`,
					component: (<ListComponent tables={ siteTypes } generalFunction={ this.resetAllTypeFunction }/>),
					picture: theme.value.pic,
					color: color
				}
				entities.push(result)
			}
		})
		return <ListComponent tables={ entities }/>
	}

	render() {
		if (this.props.stations.length > 0) {
			return (
				<div className='row no-margin'>
					<ExpansionPanel>
						<ExpansionPanelSummary
							expandIcon={ <ExpandMoreIcon/> }
							aria-controls='hydrologicalPanel-content'
							id='hydrologicalPanel-header'
						>
							<Typography>{ i18n.selectByHydrologicArea }</Typography>
						</ExpansionPanelSummary>
						<ExpansionPanelDetails className={ 'no-padding no-margin' }>
							{ this.getWatershedTabs() }
						</ExpansionPanelDetails>
					</ExpansionPanel>
					<ExpansionPanel defaultExpanded={ true }>
						<ExpansionPanelSummary
							expandIcon={ <ExpandMoreIcon/> }
							aria-controls='site-content'
							id='site-header'
						>
							<Typography>{ i18n.selectByPointType }</Typography>
						</ExpansionPanelSummary>
						<ExpansionPanelDetails className={ 'no-padding no-margin' }>
							{ this.getTabs() }
						</ExpansionPanelDetails>
					</ExpansionPanel>
				</div>
			)
		}
		return null
	}
}

StationTabPanel.propTypes = {
	stations: PropTypes.arrayOf(PropTypes.objectOf(DtoStation)),
	samplingPoints: PropTypes.arrayOf(PropTypes.objectOf(DtoSamplingPoint)),
	siteTypes: PropTypes.arrayOf(PropTypes.objectOf(DtoType)),
	keyFigures: PropTypes.arrayOf(PropTypes.objectOf(DtoKeyFigures)),
	selectedStations: PropTypes.arrayOf(PropTypes.instanceOf(DtoStation)),
	selectedSelection: PropTypes.instanceOf(DtoSelectionRow),
	selectedThemes: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.instanceOf(ThemeDto)
	})),
	themes: PropTypes.arrayOf(PropTypes.instanceOf(ThemeDto)),
	indicatorTypes: PropTypes.arrayOf(PropTypes.instanceOf(DtoIndicatorType)),
	indicators: PropTypes.arrayOf(PropTypes.instanceOf(DtoIndicator)),
	cityIndicators: PropTypes.arrayOf(PropTypes.instanceOf(DtoCityIndicator)),
	cityInformations: PropTypes.arrayOf(PropTypes.instanceOf(DtoCityInformation)),
	watershedSelected: PropTypes.arrayOf(PropTypes.instanceOf(DtoWatershed)),
	watershedLayers: PropTypes.arrayOf(PropTypes.instanceOf(DtoLayer)),
	userSite: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number
	})),
	onHover: PropTypes.bool
}

StationTabPanel.defaultProps = {
	entities: [],
	onHover: false
}

const mapStateToProps = store => {
	return {
		siteTypes: store.ReferentialReducer.siteTypes,
		indicatorTypes: store.ReferentialReducer.indicatorTypes,
		indicators: store.ReferentialReducer.indicators,
		userSite: store.DashboardReducer.userSite,
		stations: store.SitesReducer.stations,
		keyFigures: store.SitesReducer.keyFigures,
		samplingPoints: store.SitesReducer.samplingPoints,
		selectedStations: store.SitesReducer.selectedStations,
		selectedSelection: store.SitesReducer.selectedSelection,
		selectedThemes: store.AdministrationReducer.selectedThemes,
		themes: store.AdministrationReducer.themes,
		cityIndicators: store.SitesReducer.cityIndicators,
		watershedSelected: store.SitesReducer.watershedSelected,
		watershedLayers: store.SitesReducer.watershedLayers,
		cityInformations: store.SitesReducer.cityInformations
	}
}
export default connect(mapStateToProps)(StationTabPanel)



// WEBPACK FOOTER //
// ./src/sites/components/tab/StationsTabPanel.js